// A clinic is identified by its mobile number, so "the same number" has to mean one thing across the
// whole product. The same practice writes 0334 873 4518, +92 334 873 4518 and 923348734518 on three
// different forms; stored verbatim those are three clinics, which is how one practice ends up with
// two records and its cases split between them.
//
// `mobileKey` is the canonical form used for identity and duplicate detection — never for display.
// The number the user typed is kept as-is in `mobile` and is what staff and doctors read.

/**
 * Canonical identity form of a phone number: digits only, no country code, no leading zero.
 *
 *   '0334 873-4518' → '3348734518'
 *   '+92 334 8734518' → '3348734518'
 *   '00923348734518' → '3348734518'
 *
 * Returns null when there is nothing to key on. Pakistan (92) is the lab's market and the only
 * country code stripped by name; any other international prefix is left in place, which keeps two
 * genuinely different foreign numbers apart at the cost of not collapsing their two spellings.
 */
export function mobileKey(raw: string | null | undefined): string | null {
  if (!raw) return null;
  let digits = raw.replace(/\D/g, '');
  if (digits.startsWith('00')) digits = digits.slice(2);
  if (digits.startsWith('92') && digits.length >= 12) digits = digits.slice(2);
  digits = digits.replace(/^0+/, '');
  return digits.length > 0 ? digits : null;
}

/** Two numbers belong to the same clinic. */
export function sameMobile(a: string | null | undefined, b: string | null | undefined): boolean {
  const ka = mobileKey(a);
  return ka !== null && ka === mobileKey(b);
}
